// extracted by mini-css-extract-plugin
export default {"high-mileage":"Ul7vSgnBPoq6gLJ8lKdk"};